module.exports = __webpack_public_path__ + "static/img/location.5f5afb81.svg";